import { fetchBalanceSummary } from '@/api/business/bankstatement'
import { useQuery } from '@tanstack/react-query'

export const BankStatementBalanceSummary = {
    all: ['bankstatementbalancesammary'] as const,
    lists: () => [...BankStatementBalanceSummary.all, 'list'] as const,
    list: (page: number, perPage: number, filters: any) =>
        [...BankStatementBalanceSummary.lists(), page, perPage, filters] as const,
    details: () => [...BankStatementBalanceSummary.all, 'detail'] as const,
    detail: (params: string) => [...BankStatementBalanceSummary.details(), params] as const,
}

export const useBankStatmentBalanceSammaryQuery = () => {
    return useQuery({
        queryFn : () => fetchBalanceSummary(),
        queryKey: BankStatementBalanceSummary.lists(),
    })
}
